import * as types from './types'

export const updateCustomerLoginEmailField = (email) => ({
  type: types.UPDATE_CUSTOMER_LOGIN_EMAIL_FIELD,
  email,
})

export const updateCustomerLoginPasswordField = (password) => ({
  type: types.UPDATE_CUSTOMER_LOGIN_PASSWORD_FIELD,
  password,
})

export const runCustomerLoginFormValidations = () => ({
  type: types.RUN_CUSTOMER_LOGIN_FORM_VALIDATIONS,
})

export const showCustomerLoginFormValidationMessage = (success, message) => ({
  type: types.SHOW_CUSTOMER_LOGIN_FORM_VALIDATION_MESSAGE,
  success,
  message,
})

// Forgot password modal
export const showCustomerForgotPasswordModal = () => ({
  type: types.SHOW_CUSTOMER_FORGOT_PASSWORD_MODAL,
})

export const closeCustomerForgotPasswordModal = () => ({
  type: types.CLOSE_CUSTOMER_FORGOT_PASSWORD_MODAL,
})

export const updateCustomerForgotPasswordEmailField = (email) => ({
  type: types.UPDATE_CUSTOMER_FORGOT_PASSWORD_EMAIL_FIELD,
  email,
})

export const showInstructionsSentMessage = (success, message) => ({
  type: types.SHOW_INSTRUCTIONS_SENT_MESSAGE,
  success,
  message,
})

// My Account
export const showAccountName = (name) => ({
  type: types.SHOW_ACCOUNT_NAME,
  name,
})

export const customerAccountLogout = () => ({
  type: types.CUSTOMER_ACCOUNT_LOGOUT,
})

export const customerAccountLogin = (customerData) => ({
  type: types.CUSTOMER_ACCOUNT_LOGIN,
  customerData,
})

export const customerAlreadyLogin = (customer) => ({
  type: types.CUSTOMER_ALREADY_LOGIN,
  customer,
})

// email verify
export const verifyCustomerEmailAddress = () => ({
  type: types.EMAIL_EXISTS_STATUS,
  customerEmailExists: true,
})

export const invalidateVerifiedEmail = () => ({
  type: types.EMAIL_EXISTS_STATUS,
  customerEmailExists: false,
})

export const emailVerificationInProgess = (status) => ({
  type: types.EMAIL_STATUS_VERIFYING,
  emailVerificationInProgess: status,
})

export const changeEmail = (email) => ({
  type: types.CHANGE_EMAIL,
  email,
})

export const changePassword = (password) => ({
  type: types.CHANGE_PASSWORD_ACCOUNT_INFO,
  password,
})

export const showPasswordError = (message) => ({
  type: types.SHOW_PASSWORD_ERROR,
  message,
})

export const resetForm = () => ({
  type: types.RESET_FORM_FEILDS,
})

export const resetForgetPwdForm = () => ({
  type: types.RESET_FORGETPWD_FEILDS,
})

export const setCountries = (countries) => ({
  type: types.SET_COUNTRIES,
  countries,
})

export const setAccessToken = (token) => ({
  type: types.SET_TOKEN,
  token,
})

export const setUserName = (name) => ({
  type: types.SET_USER_NAME,
  name,
})

export const setUserLogin = (success) => ({
  type: types.SET_USER_LOGIN,
  success,
})

export const setSelectedCountry = (countryObj) => ({
  type: types.SET_SELECTED_COUNTRY,
  countryObj,
})

export const setUserDefaultEmail = (email) => ({
  type: types.SET_USER_DEFAULT_EMAIL,
  payload: email,
})
